import Model from "./Model";

export default class ExamApplicationModel extends Model {
  id: number;
  applicationYear: number;
  duration: number;
  examTitle: string;
  examinationBoardId: number;
  institutionId: number;
  professionalTitle: string;

  static __typename: string = "ExamApplication";

  constructor(examApplication: any, getters: any) {
    super(getters);
    this.id = examApplication.id;
    this.examTitle = examApplication.examTitle;
    this.examinationBoardId = examApplication.examinationBoardId;
    this.professionalTitle = examApplication.professionalTitle;
    this.applicationYear = examApplication.applicationYear;
    this.institutionId = examApplication.institutionId;
  }

  institution() {
    return this.getters.institutionById(this.institutionId);
  }

  examinationBoard() {
    return this.getters.examinationBoardById(this.examinationBoardId);
  }

  get title() {
    let title = '';
    if (this.examTitle) {
      title += this.examTitle + ' ';
    }
    if (this.professionalTitle) {
      title += this.professionalTitle + ' ';
    }
    if (this.applicationYear) {
      title += `( ${this.applicationYear} ) `;
    }
    return title.trim();
  }

  get text() {
    let text = this.title;
    if (this.examinationBoardId) {
      text += this.examinationBoard().title + ' ';
    }
    if (this.institutionId) {
      text += this.institution().title + ' ';
    }
    return text.trim();
  }
}
